import { Directive, TemplateRef } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[wrListItem]',
})
export class ListItemDirective<T = any> {
  constructor(
    public readonly templateRef: TemplateRef<T>,
  ) {
  }
}
